export const Search = 'search'
export const Go = 'go'
